export function emailValid(email: string) {
	if (!email) return false;
	return email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/) !== null;
}

export function passwordValid(password: string) {
	if (!password) return false;
	return password.match(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/) !== null;
}

export function nameValid(name: string) {
	if (!name) return false;
	return name.match(/^[a-zA-Z]+$/) !== null;
}

export function confirmPasswordValid(password: string, confirmPassword: string) {
	if (!password || !confirmPassword) return false;
	return password === confirmPassword;
}

export function passwordErrors(password: string) {
	if (!password) {
		return "Password is required";
	}
	if (password.length < 8) {
		return 'Password must be at least 8 characters long.';
	}
	if (!/[A-Z]/.test(password)) {
		return 'Password must contain at least one uppercase letter.';
	}
	if (!/[a-z]/.test(password)) {
		return 'Password must contain at least one lowercase letter.';
	}
	if (!/[0-9]/.test(password)) {
		return 'Password must contain at least one number.';
	}
	if (!/[^A-Za-z0-9\s]/.test(password)) {
		return 'Password must contain at least one special character.';
	}
	if (password.length > 16) {
		return 'Password can not be max 16 characters long';
	}
	return '';
}
export function nameErrors(name: string) {
	if (!name) {
		return 'Name require';
	}
	if (name.length < 3) {
		return 'name has atleast 3 character';
	}
	if (name.length > 12) {
		return 'name should below 12 character';
	}
	return '';
}
export function emailErrors(email: string) {
	if (!email) {
		return 'Email is required';
	}
	if (!email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) {
		return 'Invalid Email Address';
	}
	if (email.length > 125) {
		return 'please insert below 125 character email';
	}
	return '';
}
export function errorConfirmPassword(password: string, confirmPassword: string) {
	if (password !== confirmPassword) {
		return 'Confirm Password should same as above';
	}
	return '';
}
export function errorOTP(otp: string) {
	if (!otp.trim()) {
		return 'OTP is required';
	}
	if (!/^\d+$/.test(otp)) {
		return 'OTP must be a number';
	}
	if (otp.length < 4 || otp.length > 6) {
		return 'OTP must be between 4 to 6 digits long';
	}
	return '';
}
